CookieConsent.run({
    onConsent: function({cookie}) {
        if (typeof window.consentUpdate === 'function') {
            window.consentUpdate();
        }
    },
    onChange: function({cookie}) {
        if (typeof window.consentUpdate === 'function') {
            window.consentUpdate();
        }
    },
    revision: 1,
    guiOptions: {
        consentModal: {
            layout: 'box',
            position: 'middle center',
            flipButtons: false,
            equalWeightButtons: false,
        },
        preferencesModal: {
            layout: "box",
            equalWeightButtons: false,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true
        },
        analytics: {},
        advertisement: {}
    },
    disablePageInteraction: true,
    language: {
        default: "en",
        autoDetect: "document",
        translations: {
            en: {
                consentModal: {
                    title: "Cookie Policy",
                    description: "This website uses cookies to improve your browsing experience and provide additional features. " +
                        "By continuing to use this site, you consent to the use of cookies. " +
                        "Cookies may be used to personalize ads. Information on how Google processes data can be found <a href=\"https://business.safety.google/privacy/\">here</a>.",
                    acceptAllBtn: "OK",
                    showPreferencesBtn: "Customize",
                    footer: "<a href=\"/privacy-policy\" title=\"Privacy Policy\">Privacy Policy</a>"
                },
                preferencesModal: {
                    title: "Consent Preferences Center",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "Reject all",
                    savePreferencesBtn: "Save preferences",
                    closeIconLabel: "Close modal",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            title: "Cookie Usage",
                            description: "This site uses cookies to enhance your browsing experience and provide personalized services. By continuing to use this site, you consent to our use of cookies as outlined in our Privacy Policy."
                        },
                        {
                            title: "Essential Cookies (Always Enabled)",
                            description: "Essential cookies are necessary for the proper functioning of our website. They enable basic functions such as page navigation and access to secure areas. These cookies do not store any personal information.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Analytics Cookies",
                            description: "Analytics cookies help us improve our website by collecting and reporting information on its usage. You can set your browser to block these cookies, but some parts of the site will not work as intended.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Advertisement Cookies",
                            description: "Advertisement cookies are used to provide visitors with relevant ads and marketing campaigns. These cookies track visitors across websites and collect information to deliver personalized advertisements. You can set your browser to block these cookies, but it might affect the performance of certain features on the site.",
                            linkedCategory: "advertisement"
                        }
                    ]
                }
            },
            de: {
                consentModal: {
                    title: "Cookie-Richtlinie",
                    description: "Diese Website verwendet Cookies, um Ihr Nutzungserlebnis zu verbessern und zusätzliche Funktionen bereitzustellen. " +
                        "Wenn Sie diese Website weiter nutzen, stimmen Sie der Verwendung von Cookies zu. " +
                        "Cookies können zur Personalisierung von Werbung verwendet werden. Informationen darüber, wie Google Daten verarbeitet, finden Sie <a href=\"https://business.safety.google/privacy/\">hier</a>.",
                    acceptAllBtn: "OK",
                    showPreferencesBtn: "Anpassen",
                    footer: "<a href=\"/datenschutz\" title=\"Datenschutz-Bestimmungen\">Datenschutz-Bestimmungen</a>"
                },
                preferencesModal: {
                    title: "Zentrum für Einwilligungspräferenzen",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Alle ablehnen",
                    savePreferencesBtn: "Einstellungen speichern",
                    closeIconLabel: "Modale schließen",
                    serviceCounterLabel: "Dienst|Dienste",
                    sections: [
                        {
                            title: "Verwendung von Cookies",
                            description: "Diese Website verwendet Cookies, um Ihr Browser-Erlebnis zu verbessern und personalisierte Dienste bereitzustellen. Indem Sie diese Website weiterhin nutzen, stimmen Sie unserer Verwendung von Cookies gemäß unserer Datenschutzrichtlinie zu."
                        },
                        {
                            title: "Essenzielle Cookies (Immer aktiviert)",
                            description: "Essenzielle Cookies sind für das ordnungsgemäße Funktionieren unserer Website notwendig. Sie ermöglichen Grundfunktionen wie die Seitennavigation und den Zugang zu sicheren Bereichen. Diese Cookies speichern keine persönlichen Informationen.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Analytische Cookies",
                            description: "Analytische Cookies helfen uns, unsere Website zu verbessern, indem sie Informationen über ihre Nutzung sammeln und melden. Sie können Ihren Browser so einstellen, dass diese Cookies blockiert werden, aber einige Teile der Website funktionieren möglicherweise nicht wie vorgesehen.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Werbe-Cookies",
                            description: "Werbe-Cookies werden verwendet, um Besuchern relevante Anzeigen und Marketingkampagnen bereitzustellen. Diese Cookies verfolgen Besucher über Websites hinweg und sammeln Informationen, um personalisierte Werbung zu liefern. Sie können Ihren Browser so einstellen, dass diese Cookies blockiert werden, dies kann jedoch die Leistung bestimmter Funktionen auf der Website beeinträchtigen.",
                            linkedCategory: "advertisement"
                        }
                    ]
                }
            },
            pl: {
                consentModal: {
                    title: "Polityka cookie",
                    description: "Strona korzysta z plików cookie w celu poprawy komfortu przeglądania i dostarczania dodatkowych funkcji. " +
                        "Kontynuując korzystanie z tej strony, wyrażasz zgodę na użycie cookie. " +
                        "Pliki cookie mogą być wykorzystywane do personalizacji reklam. Informacja w jaki sposób Google przetwarza dane, znajduje się <a href=\"https://business.safety.google/privacy/\">tutaj</a>.",
                    acceptAllBtn: "OK",
                    showPreferencesBtn: "Spersonalizuj",
                    footer: "<a href=\"/polityka-prywatnosci\" title=\"Polityka prywatności\">Polityka prywatności</a>"
                },
                preferencesModal: {
                    title: "Centrum Preferencji Zgody",
                    acceptAllBtn: "Zaakceptuj wszystkie",
                    acceptNecessaryBtn: "Odrzuć wszystkie",
                    savePreferencesBtn: "Zapisz ustawienia",
                    closeIconLabel: "Zamknij modal",
                    serviceCounterLabel: "Usługa|Usługi",
                    sections: [
                        {
                            title: "Użycie Cookies",
                            description: "Ta strona używa cookies, aby poprawić Twoje doświadczenia przeglądania i świadczyć spersonalizowane usługi. Kontynuując korzystanie z tej strony, wyrażasz zgodę na nasze użycie cookies zgodnie z naszą Polityką Prywatności."
                        },
                        {
                            title: "Niezbędne Cookies (Zawsze włączone)",
                            description: "Niezbędne cookies są wymagane dla prawidłowego funkcjonowania naszej strony. Umożliwiają podstawowe funkcje takie jak nawigacja po stronie i dostęp do bezpiecznych obszarów. Te cookies nie przechowują żadnych osobistych informacji.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Cookies Analityczne",
                            description: "Cookies analityczne pomagają nam ulepszać naszą stronę poprzez zbieranie i raportowanie informacji o jej użytkowaniu. Możesz ustawić swoją przeglądarkę na blokowanie tych cookies, ale niektóre części strony mogą nie działać jak zamierzone.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Ciasteczka Reklamowe",
                            description: "Ciasteczka reklamowe są używane do dostarczania odwiedzającym odpowiednich reklam i kampanii marketingowych. Te ciasteczka śledzą odwiedzających na różnych stronach internetowych i zbierają informacje w celu dostarczania spersonalizowanych reklam. Możesz ustawić przeglądarkę, aby blokowała te ciasteczka, ale może to wpłynąć na działanie niektórych funkcji witryny.",
                            linkedCategory: "advertisement"
                        }
                    ]
                }
            },
            cz: {
                consentModal: {
                    title: "Zásady cookies",
                    description: "Tento web používá soubory cookie ke zlepšení procházení a poskytování dalších funkcí. " +
                        "Pokračováním v používání tohoto webu vyjadřujete souhlas s používáním souborů cookie. " +
                        "Soubory cookie mohou být použity k personalizaci reklam. Informace o tom, jak společnost Google zpracovává data, najdete <a href=\"https://business.safety.google/privacy/\">zde</a>.",
                    acceptAllBtn: "OK",
                    showPreferencesBtn: "Přizpůsobit",
                    footer: "<a href=\"/ochrana-osobnich-udaju\" title=\"Zásady ochrany osobních údajů\">Zásady ochrany osobních údajů</a>"
                },
                preferencesModal: {
                    title: "Centrum předvoleb souhlasu",
                    acceptAllBtn: "Přijmout vše",
                    acceptNecessaryBtn: "Odmítnout vše",
                    savePreferencesBtn: "Uložit předvolby",
                    closeIconLabel: "Zavřít modál",
                    serviceCounterLabel: "Služba|Služby",
                    sections: [
                        {
                            title: "Používání Cookies",
                            description: "Tento web používá cookies k zlepšení vašeho zážitku při procházení a poskytování personalizovaných služeb. Pokračováním v používání tohoto webu souhlasíte s naším používáním cookies, jak je uvedeno v naší Zásadách ochrany osobních údajů."
                        },
                        {
                            title: "Základní Cookies (Vždy povoleno)",
                            description: "Základní cookies jsou nezbytné pro správné fungování našeho webu. Umožňují základní funkce jako je navigace stránkou a přístup do bezpečných oblastí. Tyto cookies neukládají žádné osobní informace.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Analytické Cookies",
                            description: "Analytické cookies nám pomáhají zlepšovat náš web tím, že shromažďují a hlásí informace o jeho používání. Můžete nastavit svůj prohlížeč tak, aby tyto cookies blokoval, ale některé části webu pak nemusí fungovat jak je zamýšleno.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Reklamní Cookies",
                            description: "Reklamní cookies se používají k poskytování relevantních reklam a marketingových kampaní návštěvníkům. Tyto cookies sledují návštěvníky na různých webových stránkách a shromažďují informace, aby poskytovaly personalizované reklamy. Můžete nastavit svůj prohlížeč tak, aby tyto cookies blokoval, ale může to ovlivnit výkon některých funkcí na webu.",
                            linkedCategory: "advertisement"
                        }
                    ]
                }
            }
        }
    }
});

